<header class="global-header global-header-text Header" role="banner">
  <div class="topbar-left">
    <a href="/" class="topbar-item topbar-logo Header-logo">
      <app-svg-logo></app-svg-logo>
    </a>
  </div>
</header>
<main id="MainContent" tabindex="-1" class="Main Main--zeroState">
  <figure class="ZeroState">
    <app-svg-exclamation class="ZeroState-header"></app-svg-exclamation>
    <figcaption class="ZeroState-body">
      <h1 class="h3">The site went down unexpectedly</h1>
      <p>We are working to resolve the problem as soon as possible.</p>
      <p>Please try coming back in a bit. We apologize for any inconvenience.</p>
      <div class="ZeroState-actions">
        <p>Here are some links you may find helpful:</p>
        <!-- TODO: Add URLS to links -->
        <ul class="ZeroState-list">
          <li class="ZeroState-item">
            <a href="mailto:financialinsights@thomsonreuters.com">Contact support</a>
          </li>
          <!-- <li class="ZeroState-item">
            <a href="#">Help documentation</a>
          </li> -->
        </ul>
      </div>
    </figcaption>
  </figure>
</main>
